import type { BaseQueryFn } from '@reduxjs/toolkit/query';
import { AxiosError, AxiosRequestConfig } from 'axios';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import apiClient from '@/agent/apiClient';

import type { ReduxDispatch, ReduxState } from '../types/common.type';

export const useAppDispatch: () => ReduxDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<ReduxState> = useSelector;

interface TArgs {
  path: string;
  data?: AxiosRequestConfig['data'];
  method?: AxiosRequestConfig['method'];
  params?: AxiosRequestConfig['params'];
  headers?: AxiosRequestConfig['headers'];
  validateStatus?: AxiosRequestConfig['validateStatus'];
}

export const axiosBaseQuery: BaseQueryFn<TArgs, unknown, unknown> = ({
  path,
  method,
  data,
  params,
  headers,
  validateStatus,
}) =>
  apiClient({ url: path, method, data, params, headers, validateStatus })
    .then(r => ({ data: r.data }))
    .catch((e: AxiosError) => ({
      error: {
        status: e.response?.status,
        data: e.response?.data || e.message,
      },
    }));
